<div class="main">
  <spb-header/>
  <div class="spb-holder">
    <router-outlet/>
  </div>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    copyrightYears="2019"
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
  ></spb-footer>
</div>